const removeAccents = (obj) => {
    if (typeof obj === 'string' || obj instanceof String) {
      return obj.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }
    return obj
}
export default removeAccents